module.exports = __webpack_public_path__ + "static/media/logo-tcmax.711578ad.png";